import { useParams } from "react-router-dom";
import { blogPosts } from "@/data/blog-posts";

const Article = () => {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post)
    return <p className="text-center py-20 text-gray-600">Artículo no encontrado.</p>;

  return (
    <main className="bg-white pt-24 pb-20">

      {/* IMAGEN PRINCIPAL */}
      <div className="w-full h-[340px] md:h-[480px] overflow-hidden shadow-lg">
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-4xl mx-auto px-6 mt-14">

        {/* CATEGORÍA */}
        <span className="text-[#f4a320] font-semibold uppercase tracking-wide mb-3 block">
          {post.category}
        </span>

        {/* TÍTULO */}
        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
          {post.title}
        </h1>

        {/* FECHA */}
        <p className="text-gray-500 text-sm mb-12">
          {new Date(post.date).toLocaleDateString("es-ES", {
            day: "numeric",
            month: "long",
            year: "numeric"
          })}
        </p>

        {/* CONTENIDO DEL ARTÍCULO CON DISEÑO MEJORADO */}
        <article
          className="
            prose prose-lg max-w-none text-gray-800 text-justify

            prose-h2:text-gray-900 prose-h2:text-3xl prose-h2:font-bold prose-h2:mt-14 prose-h2:mb-4 
            prose-h2:border-l-4 prose-h2:border-[#f4a320] prose-h2:pl-4

            prose-h3:text-gray-900 prose-h3:text-2xl prose-h3:font-semibold prose-h3:mt-10 prose-h3:mb-3

            prose-p:text-[18px] prose-p:leading-relaxed prose-p:tracking-wide prose-p:mb-5

            prose-ul:pl-6 prose-ul:space-y-2 prose-ul:marker:text-[#f4a320]
            prose-li:text-[17px] prose-li:leading-relaxed

            prose-strong:text-gray-900

            prose-img:rounded-xl prose-img:shadow-lg prose-img:my-6

            prose-blockquote:border-l-4 prose-blockquote:border-[#f4a320]
            prose-blockquote:bg-gray-50 prose-blockquote:p-6 prose-blockquote:rounded-xl
            prose-blockquote:text-gray-700 prose-blockquote:my-8
          "
          dangerouslySetInnerHTML={{ __html: post.content }}
        ></article>

        {/* CTA FINAL */}
        <div className="bg-[#0B1221] text-white p-10 rounded-xl mt-16 text-center shadow-lg">
          <h3 className="text-2xl font-bold mb-3">¿Quieres reducir tu factura eléctrica?</h3>
          <p className="text-gray-300 mb-6">
            En SERGEN analizamos tus consumos, detectamos oportunidades de ahorro y te guiamos con estrategias basadas en datos.
          </p>

          <a
            href="/contacto"
            className="bg-[#f4a320] text-black px-10 py-3 rounded-lg font-semibold text-lg hover:bg-[#d88e00] transition"
          >
            Solicitar asesoría
          </a>
        </div>

      </div>
    </main>
  );
};

export default Article;
